import DOMPurify from "dompurify";

function RichText({ content }: { content: string }) {
  if (!content) {
    return <></>;
  }
  return (
    <div
      className="o-facility-content__rich-text"
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
    ></div>
  );
}

export default RichText;
